<template>
  <table
    class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400"
  >
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <slot name="head" />
      </tr>
    </thead>

    <tbody>
      <tr
        v-for="(row, index) in data"
        :key="index"
        class="bg-white border-b hover:bg-gray-50"
      >
        <td class="px-6 py-4">
          <div class="flex items-center">
            <div class="h-2.5 w-2.5 rounded-full bg-green-500 me-2"></div>
            {{ row["id"] }}
          </div>
        </td>

        <th
          scope="row"
          class="flex items-center px-6 py-4 text-gray-900 whitespace-nowrap"
        >
          <img
            class="w-10 h-10 rounded-full"
            :src="defaultImg"
            alt="Jese image"
          />

          <div class="ps-3">
            <div class="text-base font-semibold">
              {{ row["pacientes"]["nome"] }}
            </div>

            <div class="font-normal text-gray-500">
              {{ row["pacientes"]["cpf"] }}
            </div>
          </div>
        </th>

        <td scope="row" class="px-6 py-4 whitespace-nowrap">
          <div>
            <div
              :title="row['medicos']['nome']"
              class="text-base font-semibold"
            >
              {{
                row["medicos"]['nome']?.length > 20
                  ? row["medicos"]['nome'].slice(0, 20).concat("...")
                  : row["medicos"]['nome']
              }}
            </div>

            <div class="font-normal text-gray-500 lowercase">
              {{
                row["medicos"]['especialidade']?.length > 20
                  ? row["medicos"]['especialidade'].slice(0, 20).concat("...")
                  : row["medicos"]['especialidade']
              }}
            </div>
          </div>
        </td>
        
        <td class="px-6 py-4">
          <div class="flex items-center">
            <div class="h-2.5 w-2.5 rounded-full bg-green-500 me-2"></div>
            {{ formatDate(row["data"]) }}
          </div>
        </td>
        
        <!-- status -->
        <td class="px-1 py-4">
          <div class="flex items-center">
            <div
              class="h-2.5 w-2.5 rounded-full me-2"
              :class="[ row['deleted_at'] == null ? 'bg-green-500' : 'bg-red-500' ]"
            ></div>
            {{ 
              row['deleted_at'] == null ? 'em espera' : 'realizado'
            }}
          </div>
        </td>

        <!-- ações -->
        <td class="px-6 py-4">
          <div class="flex justify-center font-medium">
            <!-- Ver documento -->
            <a
              title="Editar consulta"
              class="text-yellow-600 mr-1 hover:underline cursor-pointer"
            >
              <component :is="PhNotePencil" class="h-6 w-6" />
            </a>

            <!-- relatório -->
            <a
              title="Gerar relatório"
              class="text-green-600 mr-1 hover:underline cursor-pointer"
            >
              <component :is="PhFileDoc" class="h-6 w-6" />
            </a>

            <!-- Remover documento -->
            <a
              title="Remover consulta"
              class="text-red-600 mr-1 hover:underline cursor-pointer"
            >
              <component :is="PhTrash" class="h-6 w-6" />
            </a>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script setup> ;
import {
  PhFileDoc,
  PhNotePencil,
  PhTrash,
} from "@phosphor-icons/vue";
import { defineProps } from "vue";
import moment from "moment";

const defaultImg = require("@/assets/logo/icon.png");
const props = defineProps({
  data: [Object, Array],
});

const emit = defineEmits(["delete"]);

function formatDate (date) {
  return moment(date).format('DD/MM/Y HH:mm')
}

</script>
